module.exports = __webpack_public_path__ + "static/img/beveledge.cd787db0.png";